<div class="btn-radio form-check form-switch">
    <div class="form-check form-check-inline mr-5">
        <label class="form-check-label mr-2" for="inlineRadio1"> Show primary teeth structure
        </label>
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
            (click)="toggleShowPrimary()">
    </div>
    <div class="row no-gutters mt-3">
        @for (a of teethGroupType; track 0; let idx = $index) {
        <div class="col-md-6" [class]="idx % 2 === 0 ? 'even_class' : 'odd_class'">
            <div class="row no-gutters justify-content-center">
                @for (teeth of teethGroup[a]; track $index) {
                @if (!showPrimary && !a.includes('CH') || showPrimary) {
                <ng-container *ngTemplateOutlet="teethBody;context:{teeth:teeth}"></ng-container>
                }
                }
            </div>
        </div>
        }
    </div>
</div>
<div class="col-12 form-group" *ngIf="showRemarks">
    <label>{{remarksTitle}}</label>
    <textarea class="form-control" [formControl]="remarksControl"></textarea>
</div>
<div class="col-12 text-center m-2" *ngIf="errorMsg">
    <p class="helper-text text-danger">{{errorMsg}}</p>
</div>
<div class="col-12 text-center m-2" *ngIf="showAddBtn">
    <button class="btn btn-outline-primary btn-Sub" (click)="onAdd()" [disabled]="">ADD</button>
</div>
<ng-template #teethBody let-teeth="teeth">
    <div style="padding: 0;max-width: 40px;" class="mr-1" (mouseover)="op.toggle($event);mouseOverTeethData=teeth"
        (click)="toggleTooth(teeth)">
        <div [class.selectedtooth]="teeth.selected" [style.background]="teeth?.color_code"
            class="panel panel-tile text-center br-a br-grey strutooth">
            <div class="panel-body text-center"
                style="background-color:transparent;padding:0;height: 43px;width: 100%;">
                <img [ngClass]="{'invert' : teeth?.color_code}" class="toothimg"
                    src="assets/teeth/{{teeth.imageNumber}}-tooth.svg" style="margin-left: 1px; height: 45px;">
            </div>
            <div class="panel-footer br-grey">
                <span class="fs11">
                    <h6 id="toothnumber" class="text-system text-bg-secondary" style="margin: 0;">
                        {{teeth?.toothCode}}</h6>
                </span>
            </div>
        </div>
    </div>
</ng-template>

<p-overlayPanel #op>
    <ng-template pTemplate="content">
        @if(+chartData?.[mouseOverTeethData?.toothNumber]?.length){
        @for ( d of chartData?.[mouseOverTeethData?.toothNumber] ; track d) {
        <div class="alert p-2 {{d?.color_code ? '':'alert-info'}}" [style.background]="d?.color_code"
            [style.color]="d?.color_code ? getTextcolor(d?.color_code):'none'">
            <div>
                <b>{{d?.examinationName || d?.treatmentName}}</b>
                {{' - ' + ' ( '+(d?.remarks || '') + ' )'}}
            </div>
            <div class="text-right">
                <small>
                    <b>{{d?.created_byName | titlecase}}</b>
                    {{' - ' + '('+( d?.created_at | date:'dd-MMM-yyyy') + ')'}}
                </small>
            </div>
        </div>
        }
        }
    </ng-template>
</p-overlayPanel>